module.exports = __webpack_public_path__ + "static/media/magazineTupp_04_thumb.6f7c4c97.png";